'use client'

import { queryKeys } from '@/shared/api/react-query'
import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from '@/shared/ui/use-toast'
import services from '../services'
import { CreateUploadedFileDto } from '../../lib'

const useCreateUploadedFile = (props?: { onSuccess?: () => void }) => {
  const mutationKey = [queryKeys((a, m, p) => a.uploadedFile.createUploadedFile + m.post)]

  const mutation = useMutation({
    mutationKey,
    mutationFn: async (payload: CreateUploadedFileDto) => {
      return await services.createUploadedFile(payload)
    },
    onSuccess: () => {
      toast({
        title: 'Файл добавлен в проект',
      })
      props?.onSuccess?.()
    },
  })

  useEffect(() => {
    if (mutation.isError) {
      console.error(mutation.error)
    }
  }, [mutation.error, mutation.isError])

  return mutation
}

export default useCreateUploadedFile
